export default "__VITE_ASSET__BZxgot6y__"